<ix-form
  [formGroup]="form"
  [editData]="editData()"
  [isEditMode]="resolvedEditMode()"
  [externalLoading]="externalLoading()"
  [initialFormSnapshot]="loadedSnapshot()"
  [title]="title"
  [addTitle]="addTitle"
  [editTitle]="editTitle"
  [requiredRoles]="requiredRoles"
  [submitHandler]="definition().submit"
  (closed)="closed.emit($event)"
>
  @for (section of sections; track $index) {
    @if (isSectionVisible($index, section)) {
      <tn-form-section [heading]="section.title" [tooltip]="section.tooltip">
        @for (field of section.fields; track field.name) {
          @if (isFieldVisible(field)) {
            <!-- eslint-disable no-restricted-syntax -- `field.type` is the discriminant of FormFieldDefinition,
              written as a literal by every declarative form config; each @case narrows `field` to its variant. -->
            @switch (field.type) {
              @case ('checkbox') {
                <tn-form-field [tooltip]="field.tooltip" [hint]="field.hint">
                  <tn-checkbox
                    [formControlName]="field.name"
                    [attr.data-control-name]="field.name"
                    [label]="field.label"
                    [required]="field.required"
                    [testId]="field.name"
                    [attr.id]="field.id || null"
                  ></tn-checkbox>
                </tn-form-field>
              }
              @case ('select') {
                <tn-form-field [label]="field.label" [tooltip]="field.tooltip" [hint]="field.hint">
                  <tn-select
                    [formControlName]="field.name"
                    [attr.data-control-name]="field.name"
                    [options]="(field.options | async) ?? []"
                    [multiple]="field.multiple"
                    [testId]="field.name"
                    [attr.id]="field.id || null"
                  ></tn-select>
                </tn-form-field>
              }
              @case ('combobox') {
                <tn-form-field [label]="field.label" [tooltip]="field.tooltip" [hint]="field.hint">
                  <tn-autocomplete
                    [formControlName]="field.name"
                    [attr.data-control-name]="field.name"
                    [options]="(field.options | async) ?? []"
                    [requireSelection]="field.requireSelection"
                    [allowCustomValue]="!field.requireSelection"
                    [placeholder]="field.placeholder"
                    [testId]="field.name"
                    [attr.id]="field.id || null"
                  ></tn-autocomplete>
                </tn-form-field>
              }
              @case ('chips') {
                <tn-form-field [label]="field.label" [tooltip]="field.tooltip" [hint]="field.hint">
                  <tn-chip-input
                    [formControlName]="field.name"
                    [attr.data-control-name]="field.name"
                    [options]="(field.options | async) ?? []"
                    [suggestions]="(field.suggestions | async) ?? []"
                    [allowCustomValue]="field.allowCustomValue"
                    [placeholder]="field.placeholder"
                    [testId]="field.name"
                    [attr.id]="field.id || null"
                  ></tn-chip-input>
                </tn-form-field>
              }
              @default {
                <tn-form-field
                  [testId]="field.name"
                  [label]="field.label"
                  [tooltip]="field.tooltip"
                  [hint]="field.hint"
                >
                  <tn-input
                    [formControlName]="field.name"
                    [attr.data-control-name]="field.name"
                    [name]="field.name"
                    [inputType]="field.inputType"
                    [multiline]="field.multiline"
                    [rows]="field.rows"
                    [required]="field.required"
                    [readonly]="field.readonly"
                    [placeholder]="field.placeholder"
                    [testId]="field.name"
                    [attr.id]="field.id || null"
                  ></tn-input>
                </tn-form-field>
              }
            }
            <!-- eslint-enable no-restricted-syntax -->
          }
        }
      </tn-form-section>
    }
  }
</ix-form>
